import { useMemo } from 'react';
import { isAssistantMessage } from '../../utils/domain/messageUtils';
export const useMessages = _ref => {
  let {
    messages,
    abortAssistantMessageGenerationStatus,
    statusMessagesEntries,
    streamingMessages
  } = _ref;
  const messagesWithAbortStatus = useMemo(() => messages.map(message => {
    if (message.role !== 'assistant') {
      return message;
    }
    const abortStatus = message.userMessageId ? abortAssistantMessageGenerationStatus[message.userMessageId] : undefined;
    let status = message.status;
    if (abortStatus === 'aborting') {
      status = 'requesting';
    } else if (abortStatus === 'aborted') {
      status = message.status === 'loaded' ? 'requested' : 'requesting';
    }
    return {
      ...message,
      status
    };
  }), [abortAssistantMessageGenerationStatus, messages]);
  const messagesWithStatusAndStreaming = useMemo(() => messagesWithAbortStatus.map(message => {
    if (!isAssistantMessage(message)) {
      return message;
    }
    const assistantMessage = message;
    const statusMessagesEntryByUserMessageId = statusMessagesEntries.find(entry => entry.userMessageId === assistantMessage.userMessageId);
    const statusMessageByUserMessageId = statusMessagesEntryByUserMessageId ? statusMessagesEntryByUserMessageId.statusMessages.map(item => ({
      content: item
    })) : [];
    const streamingMessageByUserMessageId = {
      content: streamingMessages[assistantMessage.userMessageId ?? ''] ?? ''
    };
    return {
      ...assistantMessage,
      statusMessage: statusMessageByUserMessageId,
      streamingMessage: streamingMessageByUserMessageId
    };
  }), [messagesWithAbortStatus, statusMessagesEntries, streamingMessages]);
  return messagesWithStatusAndStreaming;
};
//# sourceMappingURL=useMessages.js.map